import init from './init';

export default () => {
  document.addEventListener('shopify:section:load', function (e) {
    const sectionId = e.detail.sectionId;
    const sections = document.querySelectorAll(`[data-section-id="${sectionId}"]`);
    sections.forEach(function (section) {
      init(section);
    });
  });
};
